var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconBarcode = function SvgIconBarcode(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8V28H10V8H8Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8V28H13V8H12Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28V8H17V28H16Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 8V28H32V8H31Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 28V8H28V28H27Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8V28H20V8H18Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28V8H24V28H22Z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30H10V32H8V30Z",
    fill: "current"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15 30H12V32H15V30Z",
    fill: "current"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19 30V32H17V30H19Z",
    fill: "current"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23 32V30H21V32H23Z",
    fill: "current"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30H28V32H25V30Z",
    fill: "current"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32V30H30V32H32Z",
    fill: "current"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBarcode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-barcode.3bc394d5.svg";
export { ForwardRef as ReactComponent };